import type { GraphQLExtensions } from '../../types/graphql';
import { captureException } from '../../utils/error-reporter';
import { GraphQLError } from '../GraphQLError';

export interface GraphQLErrorResponse {
  message: string;
  extensions?: GraphQLExtensions;
}

export interface GraphQLResponse<T> {
  data: T;
  errors?: GraphQLErrorResponse[];
}

export const handleGqlResponse = async <GqlResponseData>(
  gqlResponsePromise: Promise<GraphQLResponse<GqlResponseData>>
): Promise<GqlResponseData> => {
  try {
    const { data, errors } = await gqlResponsePromise;

    if (errors?.length) {
      const [{ message, extensions = {} }] = errors;
      throw new GraphQLError({ message, extensions });
    }

    return data;
  } catch (gqlError) {
    captureException(gqlError);

    throw gqlError;
  }
};
